<template>
    <div class="login">
        <h3>Sign in</h3>
        <input type="text" v-model="email" placeholder="Email"><br>
        <input type="password" v-model="password" placeholder="Password"><br>
        <button :disabled="isLoggingIn" @click="login">Sign in!</button>
        <p>Don't have an account? <router-link to="sign-up">Make one!</router-link></p>
    </div>
</template>

<script>
import firebase from 'firebase';

export default {
    name: 'login',
    data() {
        return { 
            email: '',
            password: '',
            isLoggingIn: false
        };
    },
    methods: {
        login: function() {
            this.isLoggingIn = true
            firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                .then(
                    () => {
                        this.$router.replace('setup')
                    },
                    (error) => {
                        this.isLoggingIn = false
                        alert('Oops: ' + error.message)
                    }
                )
        }
    }
}
</script>

<style scoped>
.login {
    margin-top: 40px;
}
input {
    margin: 10px;
    width: 250px;
    padding: 5px;
}
button {
    margin-top: 20px;
    width: 100px;
    cursor: pointer;
}
p {
    margin-top: 40px;
    font-size: 13px;
}
p a {
    text-decoration: underline;
    cursor: pointer;
}
</style>